import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient) {
  }

  addReport(body: any) {
    return this.http.post('/api/reports/reports/', body);
  }

  fetchReports() {
    return this.http.get('/api/reports/reports/');
  }

  fetchYears() {
    return this.http.get('/api/datasource/rank-years/');
  }

  updateReport(id: number, payload: any) {
    return this.http.patch(`/api/reports/reports/${id}/`, payload);
  }

  deleteReport(id: number) {
    return this.http.delete(`/api/reports/reports/${id}/`);
  }

  getReportPdf(id: number) {
    return this.http.delete(`/api/reports/get_pdf/${id}/`);
  }

  getReportSections(id: number, year: number) {
    return this.http.get(`/api/reports/get_report_sections/${id}/${year}/`);
  }

}
